export default "__VITE_ASSET__BfGCkpHY__"